// given a number array, determine the "sign" number
export default function signUnassign(abc) {
    if (abc.length < 2 || abc.length > 3) {
        throw "less than 2 or more than 3 elements given";
    }
    let sign;
    if (abc[0] >= 0 && abc[1] >= 0) {
        sign = 0;
    }
    else if (abc[0] >= 0 && abc[1] < 0) {
        sign = 1;
    }
    else if (abc[0] < 0 && abc[1] >= 0) {
        sign = 2;
    }
    else {
        sign = 3;
    }
    if (abc.length == 3) {
        if (abc[2] < 0) {
            sign += 4;
        }
    }
    return sign;
}
